module.exports = "/static/assets/e47cd5bd430206cefd3a8a5cb4af9138.png";